import React from 'react';
import './ManagerDashboard.css';

const ManagerDashboard = () => {
  // Top Stats Data (10 cards - Manager view)
  const statsData = [
    { id: 'stat-total-enquiries', label: 'TOTAL ENQUIRIES', value: '24', sub: 'all sources' },
    { id: 'stat-pending-quotes', label: 'PENDING QUOTES', value: '8', sub: 'awaiting submission' },
    { id: 'stat-awaiting-approval', label: 'AWAITING APPROVAL', value: '5', sub: 'manager queue' },
    { id: 'stat-approved-quotes', label: 'APPROVED QUOTES', value: '12', sub: 'ready for client' },
    { id: 'stat-active-projects', label: 'ACTIVE PROJECTS', value: '7', sub: 'in execution' },
    { id: 'stat-po-value', label: 'TOTAL PO VALUE', value: '₹48,20,000', sub: 'won orders' },
    { id: 'stat-collected', label: 'COLLECTED', value: '₹22,40,000', sub: 'received' },
    { id: 'stat-outstanding', label: 'OUTSTANDING', value: '₹25,80,000', sub: 'pending' },
    { id: 'stat-team-members', label: 'TEAM MEMBERS', value: '6', sub: 'active sellers' },
    { id: 'stat-avg-deal-size', label: 'AVG DEAL SIZE', value: '₹4.2L', sub: 'last 30 days' },
  ];

  // Pipeline Stages Data (Team consolidated)
  const pipelineStages = ['Sourcing', 'Enquiry', 'Quote', 'Approval', 'PO', 'Execution', 'Payment'];
  const pipelineCounts = [12, 24, 15, 12, 8, 7, 5];
  const pipelineValues = ['₹28.5L', '₹62.3L', '₹48.2L', '₹42.1L', '₹38L', '₹35.5L', '₹22.4L'];

  // Enquiry Status Cards Data (Team aggregated)
  const enquiryStatusCards = [
    { name: 'Pending Quote', count: 8, value: '₹0', color: 'pending' },
    { name: 'Quote Submitted', count: 6, value: '₹14.2L', color: 'submitted' },
    { name: 'Approved', count: 12, value: '₹48.2L', color: 'approved' },
    { name: 'Rejected', count: 3, value: '₹0', color: 'rejected' },
    { name: 'Revision', count: 2, value: '₹4.5L', color: 'revision' },
  ];

  // Project Status Cards Data (Team aggregated)
  const projectStatusCards = [
    { name: 'Initiated', count: 3, value: '₹12.4L', color: 'initiated' },
    { name: 'In Progress', count: 7, value: '₹35.5L', color: 'progress' },
    { name: 'Completed', count: 2, value: '₹8.2L', color: 'completed' },
  ];

  // Recent Enquiries Data (All team members)
  const recentEnquiriesData = [
    { id: 'ENQ-M9K2P', client: 'Bharat Electronics', quote: '₹12,50,000', status: 'Approved', clientStatus: 'Accepted', owner: 'Priya (Sr.Exec)' },
    { id: 'ENQ-H7J3L', client: 'TechNova Solutions', quote: '₹8,20,000', status: 'Approved', clientStatus: 'Signed', owner: 'Karan (Exec)' },
    { id: 'ENQ-59AHL', client: 'Orbit Logistics', quote: '₹3,75,000', status: 'Pending Quote', clientStatus: '—', owner: 'Riya (Trainee)' },
    { id: 'ENQ-X8Y9Z', client: 'Aster Medtech', quote: '₹22,00,000', status: 'Awaiting Approval', clientStatus: 'Negotiation', owner: 'Priya (Sr.Exec)' },
    { id: 'ENQ-Q2W3E', client: 'Global Mfg Co', quote: '₹6,50,000', status: 'Quote Submitted', clientStatus: 'Under Review', owner: 'Anil (Exec)' },
  ];

  // Team Performance Data (Manager specific)
  const teamPerformanceData = [
    { name: 'Priya Sharma', role: 'Senior Exec', enquiries: 12, won: 5, value: '₹28.4L', target: '95%' },
    { name: 'Karan Mehta', role: 'Executive', enquiries: 8, won: 3, value: '₹14.2L', target: '82%' },
    { name: 'Anil Kumar', role: 'Executive', enquiries: 6, won: 2, value: '₹8.5L', target: '74%' },
    { name: 'Riya Nair', role: 'Trainee', enquiries: 4, won: 1, value: '₹3.75L', target: '68%' },
    { name: 'Sneha Iyer', role: 'Executive', enquiries: 9, won: 4, value: '₹16.9L', target: '88%' },
    { name: 'Vikram Singh', role: 'Senior Exec', enquiries: 11, won: 5, value: '₹27.5L', target: '92%' },
  ];

  return (
    <div className="manager-dashboard-container">
      <div className="manager-dashboard-wrapper">
        {/* Header Section */}
        <div className="manager-header-area">
          <h1 className="manager-title-main">📊 Manager Dashboard</h1>
          <p className="manager-title-sub">Team pipeline & performance — complete visibility</p>
        </div>

        {/* Top Stats Grid - Row 1 (5 cards) */}
        <div className="manager-top-stats-grid">
          {statsData.slice(0, 5).map((stat) => (
            <div key={stat.id} className="manager-top-stat-card">
              <div className="manager-top-stat-label">{stat.label}</div>
              <div className="manager-top-stat-value">{stat.value}</div>
              {stat.sub && <div className="manager-top-stat-sub">{stat.sub}</div>}
            </div>
          ))}
        </div>

        {/* Top Stats Grid - Row 2 (5 cards) */}
        <div className="manager-top-stats-grid">
          {statsData.slice(5, 10).map((stat) => (
            <div key={stat.id} className="manager-top-stat-card">
              <div className="manager-top-stat-label">{stat.label}</div>
              <div className="manager-top-stat-value">{stat.value}</div>
              {stat.sub && <div className="manager-top-stat-sub">{stat.sub}</div>}
            </div>
          ))}
        </div>

        {/* Pipeline Flow Section */}
        <div className="manager-pipeline-area">
          <h2 className="manager-section-heading">📈 Pipeline Flow (Team Consolidated)</h2>
          <div className="manager-pipeline-track">
            {pipelineStages.map((stage, idx) => (
              <React.Fragment key={idx}>
                <div className="manager-pipeline-node">
                  <div className="manager-pipeline-name">{stage}</div>
                  <div className="manager-pipeline-counter">{pipelineCounts[idx]}</div>
                  <div className="manager-pipeline-amount">{pipelineValues[idx]}</div>
                </div>
                {idx < pipelineStages.length - 1 && (
                  <div className="manager-pipeline-connector">→</div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Two Column Layout: Enquiry Status + Project Status */}
        <div className="manager-two-column-layout">
          {/* Enquiry Status Cards Section */}
          <div className="manager-enquiry-status-area">
            <h2 className="manager-section-heading">📋 Enquiry Status (Team)</h2>
            <div className="manager-status-cards-grid">
              {enquiryStatusCards.map((card, idx) => (
                <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
                  <div className="manager-status-card-name">{card.name}</div>
                  <div className="manager-status-card-count">{card.count}</div>
                  <div className="manager-status-card-value">{card.value}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Project Status Cards Section */}
          <div className="manager-project-status-area">
            <h2 className="manager-section-heading">🚀 Project Status (Team)</h2>
            <div className="manager-status-cards-grid">
              {projectStatusCards.map((card, idx) => (
                <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
                  <div className="manager-status-card-name">{card.name}</div>
                  <div className="manager-status-card-count">{card.count}</div>
                  <div className="manager-status-card-value">{card.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team Performance Table */}
        <div className="manager-recent-area">
          <div className="manager-recent-header">
            <h2 className="manager-section-heading">👥 Team Performance & Targets</h2>
            <a href="#" className="manager-view-all-link">Download Report →</a>
          </div>
          <div className="manager-table-wrapper">
            <table className="manager-data-table">
              <thead>
                <tr className="manager-table-header-row">
                  <th className="manager-table-header">EXECUTIVE</th>
                  <th className="manager-table-header">ROLE</th>
                  <th className="manager-table-header">ENQUIRIES</th>
                  <th className="manager-table-header">WON</th>
                  <th className="manager-table-header">VALUE</th>
                  <th className="manager-table-header">TARGET</th>
                </tr>
              </thead>
              <tbody>
                {teamPerformanceData.map((member, idx) => (
                  <tr key={idx} className="manager-table-row">
                    <td className="manager-table-cell manager-member-name">{member.name}</td>
                    <td className="manager-table-cell">{member.role}</td>
                    <td className="manager-table-cell">{member.enquiries}</td>
                    <td className="manager-table-cell manager-won-value">{member.won}</td>
                    <td className="manager-table-cell">{member.value}</td>
                    <td className="manager-table-cell">
                      <div className="manager-progress-container">
                        <span className="manager-percent">{member.target}</span>
                        <div className="manager-progress-bar">
                          <div className="manager-progress-fill" style={{ width: member.target }}></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Recent Enquiries Section with View All link */}
        <div className="manager-recent-area">
          <div className="manager-recent-header">
            <h2 className="manager-section-heading">🔄 Recent Enquiries (All Team)</h2>
            <a href="#" className="manager-view-all-link">View all →</a>
          </div>
          
          <div className="manager-table-wrapper">
            <table className="manager-data-table">
              <thead>
                <tr className="manager-table-header-row">
                  <th className="manager-table-header">ID</th>
                  <th className="manager-table-header">CLIENT</th>
                  <th className="manager-table-header">QUOTE</th>
                  <th className="manager-table-header">STATUS</th>
                  <th className="manager-table-header">CLIENT STATUS</th>
                  <th className="manager-table-header">OWNER</th>
                </tr>
              </thead>
              <tbody>
                {recentEnquiriesData.map((row, idx) => (
                  <tr key={idx} className="manager-table-row">
                    <td className="manager-table-cell">{row.id}</td>
                    <td className="manager-table-cell">{row.client}</td>
                    <td className="manager-table-cell">{row.quote}</td>
                    <td className="manager-table-cell">
                      <span className={`manager-status-badge manager-badge-${row.status.toLowerCase().replace(/\s+/g, '-')}`}>
                        {row.status}
                      </span>
                    </td>
                    <td className="manager-table-cell">
                      {row.clientStatus !== '—' ? (
                        <span className={`manager-client-badge manager-client-${row.clientStatus.toLowerCase()}`}>
                          {row.clientStatus}
                        </span>
                      ) : (
                        <span className="manager-client-badge manager-client-empty">—</span>
                      )}
                    </td>
                    <td className="manager-table-cell manager-owner-name">{row.owner}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerDashboard;